import { Directive, HostBinding, HostListener, Input } from '@angular/core';

import { SiteNavService } from '../site-nav.service';

@Directive({ selector: 'a[routerLink]' })
export class SiteLinkDirective {
  @Input() routerLink: string | any[];
  @Input() fragment: string;

  constructor(private nav: SiteNavService) {}

  @HostBinding('attr.href')
  get href(): string { return '#' + (this.fragment || ''); }

  @HostListener('click', ['$event'])
  onClick(e: MouseEvent): boolean {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button > 0) { return true; }
    this.nav.go(this.routerLink, this.fragment);
    return false;
  }
}
